import { createContext, RefObject } from 'react'
export const TtsItemContext = createContext<{
  text: string
  id: number
  scrollableParentRef?: RefObject<HTMLDivElement | null>
  toggleSpeakerFlyout: () => void
}>({
  text: '',
  id: 0,
  scrollableParentRef: undefined,
  toggleSpeakerFlyout: () => {}
})
